import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/contacts")({
  staticData: { title: "Contacts" },
  component: () => <Outlet />,
});
